var alignment_rtlignore_default = {
  "alignLeft": "ruXZQ",
  "textWrapNowrap": "QCTBG",
  "alignRight": "F-ksH",
  "alignCenter": "Q1bY-",
  "sizeFullWidth": "Q98Gv",
  "renderedInTable": "q4DIF",
  "sizeOriginal": "z1FxX",
  "sizeContent": "_4O4O-",
  "sizeSmall": "QzyVp",
  "sizeSmallCenter": "_03rr7",
  "flex": "t69kG",
  "LEFT": "x-EVr",
  "CENTER": "q4uoL",
  "RIGHT": "stzA5",
  "AUTO": "hx4v8",
  "JUSTIFY": "G2dWM"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
